<script lang="ts" setup>
</script>

<template>
    <div>
        <button>Click me</button>
    </div>
</template>
